// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}", "",{"version":3,"sources":["/app/node_modules/@quasar/extras/animate/fadeOut.css"],"names":[],"mappings":"AAAA,mBACE,GACE,SACF,CAEA,GACE,SACF,CACF,CAEA,SACE,sBACF","file":"fadeOut.css","sourcesContent":["@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  animation-name: fadeOut;\n}\n"]}]);
// Exports
module.exports = exports;
